// Official YouTube iframe embed. Per doc §9.2 we do NOT hide the YouTube logo
// or player controls and do not use any unofficial API.
export function YouTubeEmbed({ videoId, title }: { videoId: string; title: string }) {
  const src = `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?rel=0`;
  return (
    <div className="youtube-embed">
      <iframe
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
